const PUBLIC_ICON_URL = "https://glimmr.app/images/icon.png";
const PUBLIC_INSTALLER_NAME = "glimmr-setup.exe";
const PUBLIC_GOOGLE_ANALYTICS_ID = "glimmr.app";
const PUBLIC_GOOGLE_ANALYTICS_TAG = "G-MRTNWGD34M";
const PUBLIC_MICROSOFT_STORE_PRODUCT_ID = "XP89FPP9MX5S91";
export {
  PUBLIC_ICON_URL as P,
  PUBLIC_GOOGLE_ANALYTICS_ID as a,
  PUBLIC_GOOGLE_ANALYTICS_TAG as b,
  PUBLIC_INSTALLER_NAME as c,
  PUBLIC_MICROSOFT_STORE_PRODUCT_ID as d
};
